export const getUserTaskFrag = `
    id
    userId
    folderId
    title    
    dueDate
    completedAt
    createdAt
    updatedAt
    tags
    files
    shareUsers {
        id
        userTaskId
        userId
        user {
            name
            surname
            titleBeforeName
            titleAfterName
            image
        }
    }
`;

export const createTaskFrag = `
    id
`;

export const updateTaskFrag = `
    id
`;
